import {Empty, Typography, Divider} from "antd";
import React from "react";


/**
 * Convenience component to display a placeholder with replaced default image and text when no data is found
 * @param imgUrl
 * @param text
 * @param height
 * @returns {JSX.Element}
 * @constructor
 */
const Placeholder = ({
                 imgUrl='https://storage.googleapis.com/finiat-web-static-resources/utility/placeholder-3.svg',
                 text='No Data Found...',
                 height=200,
                 action
})=>{
    return (
        <Empty
            imageStyle={{height: height}}
            image={imgUrl}
            description={""}

        >
            <Typography.Text strong>{text}</Typography.Text>
            {action && (
                <>
                    <Divider/>
                    {action}
                </>

            )}
        </Empty>
    )
}
export default Placeholder;